import $ from 'jquery'
export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        function checkEmptyFiltersGroup(group) {
            if ($('.sidebar-selection input[data-filter=' + group + ']:checked').length === 0) return true;
            else return false;
        }
        var filters = {
            'currency': [],
            'interest-accrual': [],
            'capitalization': []
        };
        for (let index in filters) {
            for (let i = 0; i < $('.savings-item').length; i++)
                filters[index][i] = 0;
        }
        $('.sidebar-selection input').on('change', function () {
            var thisFilter = $(this);
            for (let index in filters) {
                if ($(thisFilter).attr('data-filter') === index) {
                    $('.savings-item').each(function (i, item) {
                        if ($(item).attr('data-' + index) === $(thisFilter).val()) {
                            if ($(thisFilter).is(':checked')) {
                                filters[index][i] = 1;
                            } else filters[index][i] = 0;
                        }
                    });
                }
            }
            var arrResult = [];
            for (let i = 0; i < $('.savings-item').length; i++) {
                arrResult[i] = 1;
                var temps = [];
                for (let index in filters) {
                    temps[index] = filters[index][i];
                    if (checkEmptyFiltersGroup(index)) filters[index][i] = 1;
                    arrResult[i] *= filters[index][i];
                    filters[index][i] = temps[index];
                }
            }
            $('.savings-item').show();
            $('.savings-item').each(function (i, item) {
                if (arrResult[i] === 0) $(item).hide();
            });
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateRetailBankingSavings.js